import React, { useState, useEffect } from 'react';
import { Modal, Input, Button, message } from 'antd';
import QRCode from 'react-qr-code';
import { generateMFA, verifyMFA } from '../../utils/mfa';
import lang from './../../languages/en';
import './styles.css';

const MFASetup = ({ visible, onClose, onSuccess }) => {
  const [secret, setSecret] = useState('');
  const [qrCodeUri, setQrCodeUri] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      handleGenerateMFA();
    }
  }, [visible]);

  const handleGenerateMFA = async () => {
    try {
      generateMFA().then(res => {
        setSecret(res.data.data.Secret);
        setQrCodeUri(res.data.data.QrCodeUri);
      })
    } catch (error) {
      message.error(lang.failed_to_generate_MFA_setup);
    }
  };

  const handleVerifyMFA = async () => {
    if (!verificationCode) {
      message.error(lang.please_enter_the_verification_code);
      return;
    }

    setLoading(true);
    try {
      const response = await verifyMFA(verificationCode, secret);

      if (response.data.code == 10001) {
        message.success(lang.MFA_setup_successful);
        onSuccess();
      } else {
        message.error(lang.invalid_verification_code);
      }
    } catch (error) {
      message.error(lang.failed_to_verify_MFA_code);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Setup Two-Factor Authentication"
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      <div className="mfa-setup-container">
        <p>Scan this QR code with your authenticator app:</p>
        {qrCodeUri && <QRCode value={qrCodeUri} size={200} />}
        <p>Or enter this secret key manually:</p>
        <div className="secret-key">{secret}</div>
        <div className="verification-input">
          <Input
            placeholder="Enter verification code"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
          />
          <Button type="primary" onClick={handleVerifyMFA} loading={loading}>
            Verify
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MFASetup;



// WEBPACK FOOTER //
// ./src/components/MFA/MFASetup.js